import { Component, EventEmitter, inject, Inject, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormModule } from 'ng-zorro-antd/form';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzInputDirective, NzInputGroupComponent } from 'ng-zorro-antd/input';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import { NZ_MODAL_DATA, NzModalFooterDirective, NzModalRef, NzModalTitleDirective } from 'ng-zorro-antd/modal';
import { NzOptionComponent, NzSelectComponent } from 'ng-zorro-antd/select';
import { UserLoggedService } from 'src/app/core/services/userLogged.service';
import { ScrapReasonService } from 'src/app/private/services/scrap-reason.service';
import { ScrapService } from 'src/app/private/services/scrap.service';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { FinalProductDto } from 'src/app/shared/dto/final-product.dto';
import { MeasurementUnitDto } from 'src/app/shared/dto/measurement-unit.dto';
import { ScrapCauseDto } from 'src/app/shared/dto/scrap-cause.dto';
import { ScrapReasonDto } from 'src/app/shared/dto/scrap-reason.dto';
import { ScrapDto } from 'src/app/shared/dto/scrap.dto';

@Component({
    selector: 'app-modal-create-scraps',
    templateUrl: './modal-create-scraps.component.html',
    styleUrls: ['./modal-create-scraps.component.scss'],
    standalone: true,
    imports: [
        NzModalTitleDirective,
        NzModalFooterDirective,
        ReactiveFormsModule,
        NzFormDirective,
        NzRowDirective,
        NzFormItemComponent,
        NzColDirective,
        NzFormControlComponent,
        NzInputDirective,
        NzSelectComponent,
        NzOptionComponent,
        NzMessageModule,
        NzFormModule,
        ReactiveFormsModule,
        FormsModule,
        NzInputGroupComponent,
        LoaderComponent,
        NzButtonModule
    ]
})
export class ModalCreateScrapsComponent implements OnInit {
    @Output() emitService = new EventEmitter();
    isLoading: boolean = true;
    isSaving: boolean = false;
    processId: number = 0;
    scrapReasons: ScrapReasonDto[] = [];
    scrapCauses: ScrapCauseDto[] = [];
    measurementUnits: MeasurementUnitDto[] = [];

    validateForm: FormGroup<{
        observations: FormControl<string>;
        quantity: FormControl<number>;
        finalProductSelected: FormControl<number | null>;
        selectedReasonId: FormControl<number | null>;
        selectedCauseId: FormControl<number | null>;
    }>;

    private readonly modalRef = inject(NzModalRef);
    private readonly userLoggedService = inject(UserLoggedService);
    private readonly message = inject(NzMessageService);
    private readonly scrapService = inject(ScrapService);
    private readonly scrapReasonService = inject(ScrapReasonService);
    private readonly fb = inject(NonNullableFormBuilder);

    constructor(@Inject(NZ_MODAL_DATA) public data: { nzTitle: string, processId: number, finalProducts: FinalProductDto[] }) { 
        this.validateForm = this.fb.group({
            observations: [''],
            quantity: [0, [Validators.required, Validators.min(0.1)]],
            finalProductSelected: new FormControl<number | null>(null, [Validators.required]),
            selectedReasonId: new FormControl<number | null>(null, [Validators.required]),
            selectedCauseId: new FormControl<number | null>(null, [Validators.required])
        });
    }

    async ngOnInit() {
        if (this.data.finalProducts.length == 1) {
            this.validateForm.controls['finalProductSelected'].setValue(this.data.finalProducts[0].id!);
        }
        this.processId = this.data?.processId as number;

        await this.getScrapReasons();

        this.isLoading = false;
    }

    getSuffix(): string {
        return this.data.finalProducts.find(fp => fp.id === this.validateForm.value.finalProductSelected!)?.article?.measurementUnit.abbreviation ?? '';
    }

    async submitForm(): Promise<void> {
        try {
            this.isSaving = true;

            if (!this.validateForm.valid) {
                this.isSaving = false;
                this.message.error(`Porfavor, rellene los campos obligatorios`);
                return;
            }

            const scrap: ScrapDto = {
                productionOrderProcessId: this.processId,
                scrapCauseId: this.validateForm.value.selectedCauseId!,
                units: this.validateForm.value.quantity ?? 0,
                observations: this.validateForm.value.observations ?? '',
                createdById: this.userLoggedService.userLogged.id,
                finalProductId: this.validateForm.value.finalProductSelected!,
                scrapReasonId: this.validateForm.value.selectedReasonId!
            };

            const createdScrap: ScrapDto = await this.scrapService.create(scrap);

            this.isSaving = false;
            this.emitService.emit(createdScrap);
            this.modalRef.close();
        } catch (e: unknown) {
            this.isSaving = false;
            if (e instanceof Error) {
                this.message.error(e.message);
            }
        }
    }

    loadCauses(reasonId: any): void {
        this.validateForm.controls['selectedCauseId'].setValue(null);

        const scrapReason = this.scrapReasons.find(
            (reason) => reason.id === +reasonId
        );

        if (!scrapReason) {
            this.message.error('No se han podido cargar las causas de tara');
            return;
        }

        this.scrapCauses = scrapReason.scrapCauses ?? [];
    }

    private async getScrapReasons(): Promise<void> {
        //TODO: FILTER BY MACHINE REVIEW WITH RUBÉN
        this.scrapReasons = await this.scrapReasonService.findAll();
    }

    handleCancel() {
        this.modalRef.close();
    }
}
